import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

/**
 * InfoTooltip - A standardized help icon with hover tooltip
 * Updated to use hover instead of click and gray background with white text
 * 
 * @param {string} instruction - The instruction text to display in the tooltip
 * @param {object} iconProps - Additional props for the IconButton
 * @param {object} tooltipProps - Additional props for the Tooltip
 */
const InfoTooltip = ({ 
  instruction, 
  iconProps = {}, 
  tooltipProps = {},
  disabled = false,
}) => {
  if (!instruction) return null;

  // Format multi-line instructions
  const formattedInstruction = instruction.split('\n').map((line, index) => (
    <React.Fragment key={index}>
      {line}
      {index < instruction.split('\n').length - 1 && <br />}
    </React.Fragment>
  ));

  return (
    <Tooltip 
      title={
        <div style={{ fontSize: '0.9rem', lineHeight: 1.5, maxHeight: 300, overflowY: 'auto' }}>
          {formattedInstruction}
        </div>
      }
      arrow 
      placement="top"
      enterTouchDelay={0}
      leaveTouchDelay={3000}
      // sx={{
      //   '& .MuiTooltip-tooltip': {
      //     backgroundColor: '#444',
      //     color: 'white',
      //     maxWidth: '400px',
      //     padding: '12px 16px',
      //     boxShadow: '0 4px 20px rgba(0,0,0,0.2)'
      //   },
      //   '& .MuiTooltip-arrow': {
      //     color: '#444'
      //   },
      // }}
      {...tooltipProps}
    >
      <IconButton 
        size="small"
        sx={{ 
          marginLeft: 1, 
          color: disabled ? '#A9A9A9' : '#42C0D1', 
          '&:hover': { 
            color: '#42C0D1',
            backgroundColor: 'rgba(66, 192, 209, 0.08)'
          },
          ...iconProps?.sx
        }}
        {...iconProps}
      >
        <InfoIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
};

export default InfoTooltip;
